export default {
    data: {
        oldpassword: "",
        password: "",
        repassword: ""
    },
    //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
    rule: {
        oldpassword: {
            type: "reg",
            rule: "^.{6,16}$",
            message: "请输入正确的原密码,6-16位"
        },
        password: {
            type: "reg",
            rule: "^.{6,16}$",
            message: "请输入正确的新密码,6-16位"
        },
        repassword: {
            type: "reg",
            rule: "^.{6,16}$",
            message: "请输入正确的确认密码,6-16位"
        }
    }
};